package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun HasteMetadata() {
    SpellMetadata(
        spellIndex = "haste",
        castingTime = "1 action",
        range = "30 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A shaving of licorice root.",
        duration = "Up to 1 minute",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = true
    )
}
